import { dimensionStyle } from "../screens/JaldiLab/Chapters/ChapterList"

export let litigantsTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "ATM",
        suggestion: "ATM",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Waiting Area",
        suggestion: "Common Waiting Area",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Filing Section",
        suggestion: "Filing Section",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Xerox",
        suggestion: "Xerox",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R1",
        process13: "R1",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Admin",
        suggestion: "Admin",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Waiting Room",
        suggestion: "Waiting Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Wash Room",
        suggestion: "Wash Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    }, {
        title: "Corridor Waiting",
        suggestion: "Corridor Waiting",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Courtroom",
        suggestion: "Courtroom",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R1",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Canteen",
        suggestion: "Canteen",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R1",
        process15: "",
        process16: "",
        process17: "R1",
        process18: "R",
    },
]

export let judgeTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Judge Chambers",
        suggestion: "Judge Chambers",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Courtroom",
        suggestion: "Courtroom",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R1",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Lounge",
        suggestion: "Lounge",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Conference Room",
        suggestion: "Conference Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
]

export let accussedTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Waiting Room",
        suggestion: "Waiting Cell",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Lift",
        suggestion: "Lift",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R1",
        process18: "R",
    },
    {
        title: "Waiting Room",
        suggestion: "Waiting Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Courtroom",
        suggestion: "Courtroom",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R1",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Lockup",
        suggestion: "Lockup",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
]

export let advocateTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "ATM",
        suggestion: "ATM",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Filing Section",
        suggestion: "Filing Section",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Bar Association Room",
        suggestion: "Bar Association Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Xerox",
        suggestion: "Xerox",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R1",
        process13: "R1",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Wash Room",
        suggestion: "Wash Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    }, {
        title: "Admin",
        suggestion: "Admin",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Case Display",
        suggestion: "Case Display",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Courtroom",
        suggestion: "Courtroom",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R1",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Lounge",
        suggestion: "Lounge",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Canteen",
        suggestion: "Canteen",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R1",
        process15: "",
        process16: "",
        process17: "R1",
        process18: "R",
    },
]

export let courtTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "ATM",
        suggestion: "ATM",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Registrar Room",
        suggestion: "Registrar Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Office",
        suggestion: "Office",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Xerox",
        suggestion: "Xerox",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R1",
        process13: "R1",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Admin",
        suggestion: "Admin",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Wash Room",
        suggestion: "Wash Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Lounge",
        suggestion: "Lounge",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Courtroom",
        suggestion: "Courtroom",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R1",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Judge Chambers",
        suggestion: "Judge Chambers",
        process1: "",
        process2: "",
        process3: "R1",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Canteen",
        suggestion: "Canteen",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R1",
        process15: "",
        process16: "",
        process17: "R1",
        process18: "R",
    },
]

export let VWDCTableData = [
    {
        title: "Entrance",
        suggestion: "Main Entrance / Exit",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "R",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Security",
        suggestion: "Security Entrance / Exit",
        process1: "R",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "R",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    },
    {
        title: "Parking",
        suggestion: "Parking",
        process1: "",
        process2: "R",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "R",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    },
    {
        title: "Security",
        suggestion: "Building Entrance Security",
        process1: "R1",
        process2: "",
        process3: "R1",
        process4: "R1",
        process5: "R1",
        process6: "R",
        process7: "",
        process8: "R1",
        process9: "R",
        process10: "R",
        process11: "R",
        process12: "R",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Waiting Room",
        suggestion: "Waiting Room 1",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Deposition Room",
        suggestion: "Deposition Room 1",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "R1",
        process10: "R1",
        process11: "R1",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Wash Room",
        suggestion: "Wash Room",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "",
        process13: "R",
        process14: "",
        process15: "",
        process16: "",
        process17: "",
        process18: "R",
    }, {
        title: "Waiting Room",
        suggestion: "Waiting Room 2",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R",
        process15: "",
        process16: "",
        process17: "R",
        process18: "R",
    }, {
        title: "Canteen",
        suggestion: "Canteen",
        process1: "",
        process2: "",
        process3: "",
        process4: "",
        process5: "",
        process6: "",
        process7: "",
        process8: "",
        process9: "",
        process10: "",
        process11: "",
        process12: "R",
        process13: "R",
        process14: "R1",
        process15: "",
        process16: "",
        process17: "R1",
        process18: "R",
    },
]


// annexure mechanical noise table

export let mechanicalNoiseTable = [{
    heading1: "Space/area",
    heading2: "Recommended Noise level",
    data: [
        {
            title: "Courtrooms",
            value: "35 dBA"
        }, {
            title: "Lounge/Library",
            value: "40 dBA"
        }, {
            title: "Judges Retiring Rooms/Chambers",
            value: "35 dBA"
        }, {
            title: "Meeting Rooms",
            value: "35 dBA"
        }, {
            title: "Court Lobby",
            value: "40 dBA"
        }, {
            title: "Public Waiting area",
            value: "40 dBA"
        }, {
            title: "Counselling Room",
            value: "35 dBA"
        }, {
            title: "Conference Room",
            value: "35 dBA"
        }, {
            title: "Office rooms",
            value: "35 dBA"
        }, {
            title: "Lobby/Reception",
            value: "40 dBA"
        }, {
            title: "Other critical areas",
            value: "35 dBA"
        }, {
            title: "Other non-critical areas",
            value: "40-45 dBA"
        }
    ]
}]
// annexure air noise table

export let airNoiseTable = [{
    heading1: "Space/area",
    heading2: "Recommended STC",
    data: [
        {
            title: "Courtroom",
            value: "STC 55"
        }, {
            title: "Conference Room",
            value: "STC 55"
        }, {
            title: "Office Room",
            value: "STC 50"
        }, {
            title: "Counselling Room",
            value: "STC 55"
        }, {
            title: "Conference Room",
            value: "STC 55"
        }, {
            title: "Other critical areas",
            value: "STC 55"
        }, {
            title: "POSCO Court",
            value: "STC 55"
        },
    ]
}]

// annexure air noise table

export let wallsTable = [{
    heading1: "STC",
    heading2: "Specification",
    data: [
        {
            title: "55",
            value: <><span style={dimensionStyle}>200mm</span> cement block (density  wall with <span style={dimensionStyle}>15mm</span> plastering on both side <span style={dimensionStyle}>1750 - 1950kg/m3</span>)</>
        }, {
            title: "55",
            value: <><span style={dimensionStyle}>165mm</span> Gypsum partition with one layer of <span style={dimensionStyle}>3mm</span> sound deadening membrane sandwiched between one layer of high density gypsum board, one layer of plain gypsum board on both sides of double <span style={dimensionStyle}>50mm</span> GI/aluminium channels with acoustic insulation separated by <span style={dimensionStyle}>20mm</span> air gap.</>
        }, {
            title: "50",
            value: <><span style={dimensionStyle}>150mm</span> cement block (density  wall with <span style={dimensionStyle}>15mm</span> plastering on both side <span style={dimensionStyle}>1750 - 1950kg/m3</span>)</>
        }, {
            title: "50",
            value: <><span style={dimensionStyle}>120mm</span> Gypsum partition with one layer of <span style={dimensionStyle}>3mm</span> sound deadening membrane sandwiched between one layer of high density gypsum board, one layer of plain gypsum board on both sides of single <span style={dimensionStyle}>70mm</span> GI/aluminium channels with acoustic insulation separated by <span style={dimensionStyle}>20mm</span> air gap.</>
        }
    ]
}]

// author table

export let authorsTable = [
    {
        title1: "Vidhi Fellows",
        title2: "Shreya Tripathy",
        title3: "Priyamvadha Shivaji",
        title4: "",
    },
    {
        title1: "Urban Design Expert",
        title2: "Brinda Sastry",
        title3: "",
        title4: "",
    },
    {
        title1: "Accessibility Expert",
        title2: "Shreya Shetty",
        title3: "Bhagya Chandragude",
        title4: "",
    },
    {
        title1: "Illustrators",
        title2: "Abubakar Shaikh",
        title3: "Gayatri Ganesh",
        title4: "",
    },
    {
        title1: "Security Expert",
        title2: "Milind D P",
        title3: "",
        title4: "",
    }, {
        title1: "Acoustics Expert",
        title2: "Arun",
        title3: "",
        title4: "",
    }, {
        title1: "Internal Peer Review (ongoing)",
        title2: "Deepika Kinhal",
        title3: "",
        title4: "",
    }, {
        title1: "External Peer Review(ongoing)",
        title2: "Damini Ghosh",
        title3: "Sanjay Kanvinde",
        title4: "",
    }, {
        title1: "Internal Consultations",
        title2: "Alok Prasanna Kumar",
        title3: "Manmayi Sharma",
        title4: "Rahul Bajaj",
    }, {
        title1: "",
        title2: "Yashaswini Basu",
        title3: "Yogini Oke",
        title4: "Shireen Yachu",
    }, {
        title1: "Consultations (Judiciary)",
        title2: "Hon’ble Justice Badar Durez Ahmed",
        title3: "Hon’ble Justice Naveen Rao",
        title4: "Mr. Suresh Kogilgere",
    }, {
        title1: "Consultations (Psychology)",
        title2: "Dr. Tanya Machado",
        title3: "Dr. Ria Fernandez",
        title4: "",
    }, {
        title1: "Consultations (Rehabilitation and Reformation)",
        title2: "Akhilesh (Project Second Chance)",
        title3: "",
        title4: "",
    }, {
        title1: "JALDI Interns",
        title2: "Adithi Holla",
        title3: "Ojaswi Singh",
        title4: "Divyanshi Sharma",
    }, {
        title1: "",
        title2: "Kartheek Vegesana",
        title3: "Siddhant Mishra",
        title4: "Sneha Mohan",
    }, {
        title1: "",
        title2: "Priyanshi Shrivastava",
        title3: "Navya Singh",
        title4: "Krishnapriya Nair",
    },

]

//associated tools

export let associatedTools = [
    {
        item: "Physical and Mobility Impairments:",
        subData: [
            {
                subItem: "Accessible Transportation Options:",
                nestedItem: [
                    "Accessible Transport Drop-Off Points: Designated with ramp access and proximity to Court Complex entrances.",
                    "Provision of accessible information on public transport options to and from the Court Complex."
                ]
            },
            {
                subItem: "Accessible Security Checkpoints:",
                nestedItem: [
                    "Accessible Screening Equipment: Security screening at heights reachable by wheelchair users or those with mobility aids.",

                    "Assistance for Security Checks: Provision of aid and alternative screening facilities for those with mobility or sensory impairments."
                ]
            },
            {
                subItem: "Accessible Parking: Designated parking spaces close to the accessible entrances with proper signage.",
            }, {
                subItem: "Ramps and Elevators: Wheelchair-accessible ramps and elevators for easy movement between different floors.",
            },
            {
                subItem: "Accessible public services:",
                nestedItem: [
                    "Accessible Information Desks: Equipped with communication aids such as hearing loops and communication boards.",

                    "Accessible Service Counters: Designed with lowered sections to accommodate wheelchair users during transactions."
                ]
            },
            {
                subItem: "Assistance for Navigation: Provision of staff or volunteers to assist persons with disabilities in navigating the Court Complex.",
            }, {
                subItem: "Assistance Services: Access to court staff or volunteers to assist persons with mobility challenges.",
            }, {
                subItem: "Wide Doorways and pathways/corridors: Entrance doors and internal doorways wide enough to accommodate wheelchairs.",
            }, {
                subItem: "Accessible Courtroom Seating: Designated and flexible seating areas within courtrooms with adequate space to accommodate wheelchairs and mobility aids.",
            }, {
                subItem: "Accessible Courtroom Amenities: Water dispensers and other amenities are positioned at accessible heights.",
            }, {
                subItem: "Accessible Courtroom Controls: Controls for lights, temperature, and audio-visual equipment positioned at accessible heights.",
            }, {
                subItem: "Accessible Witness Stands and Defendant Areas:",
                nestedItem: [
                    "Clear access paths with ramps to witness stands and defendant areas to ensure ease of entry and exit for persons using mobility aids.",

                    "Accessible witness and defendant stands designed to accommodate wheelchairs with supportive seating options or those who require seated presentations."
                ]
            }, {
                subItem: "Assistive Writing and Reading Aids:",
                nestedItem: [
                    "Ergonomic Writing Aids: Writing aids designed to assist persons with motor impairments in filling out forms or taking notes.",

                    "Adjustable Book Stands: Stands that can be modified to support reading documents comfortably."
                ]
            }, {
                subItem: "Accessible Washrooms:",
                nestedItem: [
                    "Washrooms equipped with grab bars, lower sinks, and adequate space for wheelchair manoeuvrability.",

                    "Accessible washrooms for diverse demographics, such as third gender, family toilets, etc."
                ]
            }, {
                subItem: "Remote Access Technology: Video conferencing facilities for remote participation in Court proceedings for persons with mobility or health issues."
            },
        ]
    },

    {
        item: "Visual Impairments: ",
        subData: [
            {
                subItem: "Tactile Ground Surface Indicators (“TGSIs”): Textured surfaces indicating paths, stairs, and hazards for those with visual impairments.",
            },
            {
                subItem: "Assistance for Navigation: Tactile maps placed at strategic locations to aid in navigating the Court Complex independently.",
            }, {
                subItem: "Braille Signage: Signage with Braille text to help navigate the Court Complex independently.",
            }, {
                subItem: "High-Contrast Signage: Utilising bold colours and large fonts on signs to improve visibility for those with low vision.",
            }, {
                subItem: "Guided Navigation Systems: Using auditory or tactile cues for guided navigation to assist in navigating the Court Complex.",
            }, {
                subItem: "Accessible Emergency Alarms: Emergency alarms equipped with visual and tactile alerts in addition to auditory signals.",
            }, {
                subItem: "Audio Description Services: Providing verbal descriptions of visual content like Courtroom proceedings, exhibits, and documents to aid persons with visual impairments in understanding.",
            }, {
                subItem: "Accessible Court Exhibits: Interactive audio descriptions or tactile representations to engage with courtroom evidence.",
            }, {
                subItem: "Assistive Technology: Access to computers equipped with screen readers and magnification software for accessing legal documents.",
            }, {
                subItem: "Service Animals / Guide Dogs:",
                nestedItem: [
                    "Provision for persons with visual impairments to be accompanied by guide dogs within the Court Complex.",

                    "Designated spaces for relief and care of assistance animals."
                ]
            }, {
                subItem: "Assistive Technology Training: Conducting sessions on using tools like screen readers and magnification software to access court information effectively."
            },
        ]
    },

    {
        item: "Speech and Hearing Impairments:",
        subData: [
            {
                subItem: "Emergency Communication Boards: Communication boards with pictograms and text for persons with speech or hearing impairments during emergencies.",
            },
            {
                subItem: "Quiet Spaces: Designating quiet areas within Court Complexes for persons with hearing impairments to seek respite from noise and distractions during breaks in proceedings."
            }, {
                subItem: "Visual Alerts: Visual alerts for emergency announcements and courtroom notifications."
            }, {
                subItem: "Simplified Language Use: Encouraging the use of simplified language by legal professionals and Court staff to enhance understanding for persons with hearing impairments or cognitive disabilities."
            }, {
                subItem: "Captioning Services: Providing real-time captioning of spoken content during Court proceedings for persons with hearing impairments to follow along."
            }, {
                subItem: "Sign Language Interpreters: Provision of sign language interpreters for effective communication during Court proceedings."
            }, {
                subItem: "Assistive Listening Devices: Offering portable assistive listening devices with headphones or earpieces for persons with mild to moderate hearing impairments to amplify during proceedings."
            }, {
                subItem: "Induction Loop Systems: Hearing loop systems in courtrooms for persons with hearing aids to access auditory information."
            }, {
                subItem: "Large screens or monitors displaying real-time transcription for persons with hearing impairments or those seated at a distance."
            }, {
                subItem: "Clear instructions for the use of assistive listening devices and assistance provided by Court staff if needed."
            }, {
                subItem: "Remote Access Technology: Real-time transcription services for remote participants with hearing impairments."
            }, {
                subItem: "Remote Interpretation Services: Utilising remote interpretation services via video conferencing for persons who require sign language interpretation or captioning during Court proceedings."
            },
        ]

    },
    {
        item: "Cognitive Disabilities:",
        subData: [
            {
                subItem: "Pre-Visit Resources: Offering pre-visit resources such as virtual tours to familiarise with the Court environment and proceedings, reducing anxiety and promoting confidence.",
            }, {
                subItem: "Accessible Support Materials: Providing supplementary materials in easy-to-understand formats, including pictorial guides and plain language handouts, to assist in understanding Court procedures and their rights.",
            }, {
                subItem: "Visual Cues: Incorporating visual cues such as colour-coded signs or symbols, clear and simple signage to aid in navigation and orientation within the Court Complex.",
            }, {
                subItem: "Personalised Support: Offering personalised support services, such as guided tours or assistance from trained Court staff, to address the specific needs and facilitate their participation in Court activities.",
            }, {
                subItem: "Calming Sensory Environment: Creating sensory-friendly environments within designated quiet spaces, including dim lighting, comfortable seating, and noise-reducing elements, to accommodate persons who may be easily overwhelmed.",
            }, {
                subItem: "Visual Schedules: Offering visual schedules or timetables outlining the sequence of Court proceedings or appointments to aid in understanding and preparing for their legal obligations.",
            }, {
                subItem: "Time Management Support: Provide infrastructural support to assist with time management and scheduling to help navigate Court appearances and appointments effectively.",
            }, {
                subItem: "Flexible Court Procedures: Facilitate flexible Court procedures, such as breaks or simplified questioning techniques, to accommodate processing speed and comprehension abilities during legal proceedings.",
            }, {
                subItem: "Accessible Communication Aids: Providing communication aids such as picture communication boards or augmentative and alternative communication (AAC) devices to facilitate effective communication during court interactions.",
            }, {
                subItem: "Supportive Accompaniment: Allowing for the presence of a trusted support person or advocate to accompany during Court proceedings to provide assistance, reassurance, and advocacy as needed.",
            },
        ]
    },
    {
        item: "Multiple Disabilities:",
        subData: [
            {
                subItem: "Universal Design Principles: Applying universal design principles throughout the Court Complex and services to ensure inclusivity for all."
            },
            {
                subItem: "Sensory Integration Strategies: Incorporating sensory integration strategies into the design of the Court Complex, such as adjustable lighting, noise reduction measures, and sensory-friendly spaces, to support persons with multiple disabilities who may experience sensory processing challenges."
            },
            {
                subItem: "Personalised Support Plans: Developing personalised support plans in collaboration with persons with multiple disabilities and their support networks, outlining specific accommodations, assistance, and strategies customised to their unique needs and preferences."
            },
            {
                subItem: "Communication Accessibility and Interpreting Services: Providing a range of interpreting services beyond sign language interpretation, including tactile signing, close vision interpreting, alternative communication methods, and visual aids and oral interpretation, to accommodate diverse communication needs."
            },
            {
                subItem: "Cultural and Linguistic Sensitivity:",
                nestedItem: [
                    "Ensuring cultural and linguistic sensitivity in providing accommodations and support services, recognizing and respecting the diversity of backgrounds and experiences.",

                    "Language Translation Services: Ensuring access to language translation services for persons  with limited proficiency in the dominant court language.",
                ]
            },
            {
                subItem: "Interdisciplinary Support Teams: Establishing interdisciplinary support teams consisting of professionals from various fields such as rehabilitation, psychology, and social work to provide holistic support and assistance."
            },
            {
                subItem: "Assistive Technology Integration: Integrating a wide range of assistive technology devices and software applications into Court facilities, such as speech-to-text software, communication devices, and adaptive computer interfaces, to enhance accessibility and facilitate communication and information access."
            },
            {
                subItem: "Accessible Information and Resources: Providing accessible information and resources in various formats, such as easy-to-read documents, braille materials, and digital resources, to empower and make them understand their rights, responsibilities, and legal options within the Court system."
            },
            {
                subItem: "Accessible Legal Education: Providing customised resources such as plain language guides, multimedia presentations, and interactive workshops for understanding their legal rights and responsibilities."
            },

        ]
    }
    ,
    {
        item: "Senior Citizens, Persons with Temporary Disabilities, Third Gender Persons, Expectant Mothers, Young Mothers, Young Families, and Children:",
        subData: [
            {
                subItem: "Senior Citizens:",
                nestedItem: [
                    "Priority Services: Expedited procedures for seniors to reduce waiting times.",
                    "Assistance Services: Dedicated staff to aid seniors with forms and navigation.",
                    "Seating Accommodations: Comfortable seating with armrests throughout the Court Complex.",
                    "Accessible Rest Areas: Designated quiet areas with seating and amenities for breaks.",
                ]
            }, {
                subItem: "Persons with Temporary Disabilities",
                nestedItem: [
                    "Temporary Parking Permits: Reserved parking near entrances for temporary disability access.",
                    "Accessibility Assistance: Provision of mobility aids like wheelchairs, crutches, walking aids, etc.",
                    " Flexible Accommodation Options: Adjustable seating and extended breaks.",
                    "Information Assistance: Guided tours for court familiarity.",
                ]
            }, {
                subItem: "Third Gender Persons:",
                nestedItem: [
                    "Gender-Inclusive Facilities: Offering gender-neutral washrooms and changing areas.",
                    "Respectful Pronouns: Training staff on using preferred pronouns.",
                    "Cultural Sensitivity and Training: Promoting awareness, sensitization and training staff  on diverse needs.",
                    "Access to Services: Referral assistance for accessing relevant resources.",
                    "Representation: Advocating for third-gender rights.",
                    "Confidentiality: Ensuring privacy and non-discrimination.",
                ]
            }, {
                subItem: "Expectant Mothers:",
                nestedItem: [
                    "Priority Seating: Designated areas for expectant mothers' comfort.",
                    "Accessible Washrooms:  Washrooms with baby-changing stations.",
                    "Flexible Scheduling: Options to accommodate medical and emergency needs.",
                    "Assistance Services: Support with courtroom access and belongings.",
                ]
            }, {
                subItem: "Young Mothers:",
                nestedItem: [
                    "On-site Childcare: Supervised play areas for children during court visits.",
                    "Breastfeeding Rooms: Private spaces equipped for nursing or pumping.",
                    "Family-Friendly Facilities: Amenities like stroller parking and diaper-changing stations.",
                    "Flexible Scheduling: Options for accommodating childcare needs.",
                    "Parenting Support: Workshops and programs tailored for young mothers.",
                    "Information Services: Referral assistance for accessing relevant resources.",
                    "Sensitivity Training: Education for staff on young mothers' unique needs.",
                ]
            }, {
                subItem: "Young Families:",
                nestedItem: [
                    "Child Safety Measures: Ensure safe areas for children.",
                    "Family Facilities: Provide amenities like nursing rooms.",
                    "Flexible Options: Adjustments for parents with children.",
                    "Child-Friendly Areas: Equipped with age appropriate multiple activity areas, toys, educational material, etc., to engage children  during Court visits.",
                    "Family Washrooms: Include baby-changing stations and child-sized fixtures.",
                    "Childcare Assistance: Onsite services for children during proceedings.",
                    "Parenting Support: Workshops tailored for young families.",
                    "Child Advocacy: Resources for children's rights and support.",
                ]
            }, {
                subItem: "Children:",
                nestedItem: [
                    "Child-Friendly Waiting Areas: Equipped with age appropriate multiple activity areas, toys, educational material, etc., to engage children.",
                    "Family Washrooms: Include child friendly features, changing stations, etc., in the",
                    "Childcare Services: Offered for children during Court visits.",
                    "Educational Materials: Designed to explain court procedures to children.",
                ]
            },
        ]
    }
    ,
    {
        item: "Accessible Legal Documents:",
        subData: [
            {
                subItem: "Multilingual Accessibility: Providing legal documents in multiple languages to cater to persons with limited proficiency in the dominant Court language, ensuring equitable access to legal information and proceedings.",
            }, {
                subItem: "Braille Documents: Offering legal documents in Braille format for persons who rely on tactile reading to access written information effectively.",
            }, {
                subItem: "Accessible Audio Formats: Providing legal documents in audio format to accommodate persons with visual impairments or print disabilities who may benefit from auditory information access.",
            }, {
                subItem: "Multilingual Accessibility: Providing legal documents in multiple languages to cater to persons with limited proficiency in the dominant Court language, ensuring equitable access to legal information and proceedings.",
            }, {
                subItem: "Accessible Legal Documents: Ensuring that electronic versions of legal documents are created in accessible formats, compatible with screen readers, and other assistive technologies commonly used by Persons with Disabilities.",
            }, {
                subItem: "Interactive Forms: Developing interactive and editable forms for legal documents, allows users to complete and submit forms electronically with ease, reducing barriers to accessing legal services and information.",
            }, {
                subItem: "Accessible Metadata: Incorporating descriptive metadata and document properties to enhance accessibility and searchability of legal documents for persons using assistive technologies, improving navigation and information retrieval capabilities.",
            }, {
                subItem: "Accessible Markup Language: Utilising accessible markup language techniques such as HTML to create online legal documents, facilitating navigation and comprehension when using web-based assistive technologies.",
            }
        ]
    },
    {
        item: "Accessible and Assistive Technology Interface:",
        subData: [
            {
                subItem: "Accessible Court Websites:",
                nestedItem: [
                    "Court websites designed with accessibility features such as alt text for images, keyboard navigation, and resizable text.",
                    "Accessible formats for downloadable Court forms and documents.",
                ]
            }, {
                subItem: "Remote Accessibility Support: Providing remote technical support and assistance to troubleshoot accessibility issues with software, devices, or assistive technology tools.",
            }, {
                subItem: "Customisable User Interfaces: Implementing customisable user interfaces and settings on computers and devices to allow persons with diverse needs to adjust display settings, keyboard shortcuts, and other preferences for optimal accessibility.",
            }, {
                subItem: "Alternative Input Devices: Offering alternative input devices such as trackballs, joysticks, or virtual keyboards for persons with mobility impairments who may have difficulty using standard computer peripherals.",
            }, {
                subItem: "Voice Recognition Software: Providing voice recognition software for persons with physical disabilities or limitations in typing, enabling them to control computers and input text using spoken commands",
            }, {
                subItem: "Captioning and Subtitling: Ensuring the availability of captioning and subtitling options for multimedia content such as videos and presentations, making them accessible to persons with speech and hearing impairments.",
            }, {
                subItem: "Customisable User Interfaces: Implementing customisable user interfaces and settings on computers and devices to allow persons with diverse needs to adjust display settings, keyboard shortcuts, and other preferences for optimal accessibility.",
            }, {
                subItem: "Screen Magnification Tools: Providing access to screen magnification software for persons with low vision, allowing them to enlarge text and graphics on computer screens for improved readability.",
            }, {
                subItem: "Refreshable Braille Displays: Offering refreshable Braille displays connected to computers or mobile devices, allows persons with visual impairments to read digital content through tactile feedback.",
            }, {
                subItem: "Accessibility Features in Mobile Applications: Incorporating accessibility features such as voice commands, screen magnification, and gesture controls into mobile applications to ensure usability on smartphones and tablets.",
            },
        ]
    }
    ,
    {
        item: "Training for Court Staff:",
        subData: [
            {
                subItem: "Sensitivity Training: Conducting continuous training programs for Court staff to create disability awareness and promote understanding of the diverse needs of Persons with Disabilities, fostering a dignified and inclusive environment within the Court Complex.",
            }, {
                subItem: "Legal Obligations and Best Practices: Providing comprehensive training on legal obligations, rights, and best practices related to disability accommodations and accessibility in the Court system, ensuring compliance with relevant laws and regulations.",
            }, {
                subItem: "Effective Communication Skills: Providing training sessions focused on developing effective communication skills specifically customised to interacting with Persons with Disabilities, including strategies for clear and respectful communication, active listening, non-verbal cues, etc.",
            }, {
                subItem: "Assistive Technology Proficiency: Offering training sessions to equip Court staff with the necessary skills to operate and assist with accessibility tools and technology available within the Court Complex, such as screen readers, magnification software,hearing assistive devices, etc.",
            }
        ]
    }

]

export let annexureSevenData = [
    {
        data1: "SDG 5",
        data2: "Achieve gender equality and empower all women and girls",
        data3: <>
            <p>5.1. End all forms of discrimination against all women and girls everywhere.</p>
            <p>5.c. Adopt and strengthen sound policies and enforceable legislation for the promotion of gender equality and the empowerment of all women and girls at all levels.</p>
        </>,
        data4: <>
            <p>All spaces in the Court Complex have been designed to be accessible to all users. </p>
            <p>Special services have been provided for female advocates, staff and litigants.</p>
            <p>Special facilities have been provided to individuals belonging to the third gender. </p>
            <p>The Handbook also recommends that Gender Sensitization Training must be undertaken on a regular basis. </p>
        </>,

    },
    {
        data1: "SDGs  9 and 12",
        data2: <>
            <p>9. Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation</p>
            <p>12. Ensure sustainable consumption and production patterns</p>
        </>,
        data3: <>
            <p>
                9.1. Develop quality, reliable, sustainable and resilient infrastructure, including regional and transborder infrastructure, to support economic development and human well-being, with a focus on affordable and equitable access for all.
            </p>
            <p>
                12.5 By 2030, substantially reduce waste generation through prevention, reduction, recycling and reuse.
            </p>
            <p>
                12.7. Promote public procurement practices that are sustainable, in accordance with national policies and priorities.
            </p>
        </>,
        data4: <>
            <p>
                Sustainability is one of the 5 principles adopted in this Handbook.
            </p>
            <p>
                The Handbook prescribes Court Complex design that is energy-conscious and affordable to resource use.
            </p>
            <p>
                The Handbook also recommends that practices that promote biodiversity and ecosystem health should be followed while planning and constructing a Court Complex. This includes using native flora for low-maintenance landscaping, and drought-resistant plants to reduce water needs.
            </p>
        </>,

    },
    {
        data1: "SDG 11 ",
        data2: <>
            <p>Make cities and human settlements inclusive, safe, resilient and sustainable</p>

        </>,
        data3: <>
            <p>
                11.7. By 2030, provide universal access to safe, inclusive and accessible, green and public spaces, in particular for women and children, older persons and persons with disabilities.
            </p>
            <p>
                11.b. By 2020, substantially increase the number of cities and human settlements adopting and implementing integrated policies and plans towards inclusion, resource efficiency, mitigation and adaptation to climate change, resilience to disasters, and develop and implement, in line with the Sendai Framework for Disaster Risk Reduction 2015–2030, holistic disaster risk management at all levels.
            </p>
        </>,
        data4: <>
            <p>
                Accessibility is one of the 5 principles adopted in this Handbook.
            </p>
            <p>
                The Handbook prescribes a universal design approach to Court infrastructure.
            </p>
            <p>
                All spaces in the Court Complex are prescribed to be designed to be accessible for diverse user groups.
            </p>
            <p>
                Specific recommendations are provided for ensuring provision of accessible emergency evacuation facilities for diverse user groups in times of emergencies. It also recommends that training and capacity building sessions must be conducted to ensure the needs of all users are understood and considered.
            </p>
        </>,

    },

    {
        data1: "SDG 16",
        data2: <>
            <p>
                Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels
            </p>
        </>,
        data3: <>
            <p>
                16.3. Promote the rule of law at the national and international levels and ensure equal access to justice for all.
            </p>
            <p>
                16.7. Ensure responsive, inclusive, participatory and representative decision-making at all levels.
            </p>
            <p>
                16.10. Ensure public access to information and protect fundamental freedoms, in accordance with national legislation and international agreements.
            </p>
        </>,
        data4: <>
            <p>
                The Handbook seeks to transform Court Complexes into places where the experience of providing and seeking justice is significantly improved.
            </p>
            <p>
                The Handbook recommends a user-centric approach to Court Complex design to ensure that all spaces are easily navigable by diverse user groups, including first-time participants in the legal system.
            </p>
            <p>
                The Handbook emphasises the need to uphold the rights of vulnerable witnesses and accused persons, while balancing safety interests and comfort of all users.
            </p>
            <p>
                Additionally, the Handbook seeks to provide efficient and comfortable workspaces for stakeholders within the system, including judges, advocates, and Court staff.
            </p>
            <p>
                The Handbook also provides for e-Seva Kendras to ensure public access to information for all users.
            </p>
        </>,

    },

    {
        data1: "SDG 17",
        data2: "Strengthen the means of implementation and revitalize the Global Partnership for Sustainable Development",
        data3: "17.8. Fully operationalize the technology bank and science, technology and innovation capacity-building mechanism for least developed countries by 2017 and enhance the use of enabling technology, in particular information and communications technology.",
        data4: "The Handbook seeks to incorporate all relevant technological developments in all spaces within the Court Complex. ",
    },

]

export let applicationDev = [
    {
        item: "Conduct a comprehensive User Analysis:",
        subData: [
            { subItem: "Conduct a comprehensive user analysis by considering the diverse demographics and cultural backgrounds of users to ensure inclusivity and accessibility in the app design and functionality." },
            {
                subItem: "Analyse user preferences and behaviours to customise the app's features and functionalities that address their key pain points, needs and challenges to enhance the overall user experience."
            },
            { subItem: "Determine accessibility needs for persons with visual, mobility, and hearing impairments." },
            { subItem: "Collect navigation requirements from Court personnel, judges, lawyers, and visitors." },
        ]
    },
    {
        item: "Designing and Development of the App",
        subData: [
            { subItem: "Create user personas representing different user groups (as defined in this Handbook) to guide the design process." },
            { subItem: "Collaborate with Court administrators and architects to obtain detailed accessibility maps/plans/features and floor plans. Integrate them into the app for navigation purposes." },
            { subItem: "Use indoor mapping technologies to create detailed floor plans of the court complex." },
            { subItem: "Overlay accessibility features onto the floor plans, highlighting accessible routes, restrooms, elevators, and amenities." },
            { subItem: "Ensure that these plans and features are regularly updated to reflect any changes or renovations within the Court Complex." },
            { subItem: "Allow users to customise displays for specific accessibility needs, like visual or hearing aid compatibility." },
        ]
    },
    {
        item: "Incorporate Accessibility Features:",
        subData: [
            { subItem: "Provide alternative navigation options for users with mobility impairments, such as elevators and ramps." },
            { subItem: "Include text-to-speech functionality for persons with visual impairments to receive audible directions and information." },
            { subItem: "Ensure compatibility with assistive technologies and incorporate accessibility features (such as high contrast modes, screen reader compatibility, voice navigation, etc.),  commonly used by Persons with Disabilities." },
        ]
    },
    {
        item: "Undertake Prototyping and Testing:",
        subData: [
            { subItem: "Design an intuitive and user-friendly interface that accommodates diverse user needs." },
            { subItem: "Develop wireframes and prototypes to validate the design with potential users and stakeholders." },
            { subItem: "Implement step-by-step navigation." },
            { subItem: "Incorporate location-based services using GPS and Bluetooth beacons to enhance accuracy, especially for persons with visual and hearing impairments." },
            { subItem: "Perform accessibility testing with users representing different disabilities to ensure the app meets their needs." },
            { subItem: "Implement a feedback mechanism for users to report issues and suggest improvements." },
            { subItem: "Conduct thorough testing to identify and fix any usability/functionality issues, bugs, or security vulnerabilities." },
        ]
    },
    {
        item: "Incorporate sophisticated Security Protocols:",
        subData: [
            { subItem: "Deploy advanced security measures to safeguard app access and sensitive data." },
            { subItem: "Implement multi-factor authentication (MFA) for secure user access." },
            { subItem: "Utilise end-to-end encryption to protect communication with backend servers to prevent data breaches." },
            { subItem: "Secure user data with tokenization to prevent unauthorised access or tampering." },
            { subItem: "Conduct regular security audits and penetration testing for proactive vulnerability management." },
        ]
    },
    {
        item: "Develop a Secure Backend Infrastructure:",
        subData: [
            { subItem: "Establish a robust system for handling user data, authentication, and authorisation securely." },
            { subItem: "Employ stringent encryption protocols to safeguard sensitive information and maintain data privacy." },
            { subItem: "Integrate seamlessly with existing Court Complex information systems, such as e-Seva Kendras, listing branch, etc., to offer real-time information." },
            { subItem: "Ensure compatibility and interoperability with other backend systems to facilitate smooth data exchange and operation." },
        ]
    },
    {
        item: "Conduct Training Programs:",
        subData: [
            { subItem: "Deploy the app through secure app stores, implementing appropriate access controls and permissions." },
            { subItem: "Conduct comprehensive training sessions for Court staff, security personnel, and other stakeholders to maximise proficiency in app usage and support." },
            { subItem: "Offer ongoing support and resources to address any challenges or questions that may arise post-deployment." },
            { subItem: "Collaborate with IT teams and administrators to ensure smooth integration of the app into existing workflows and processes." },
            { subItem: "Collect feedback from users during training sessions to identify areas for improvement and tailor support resources accordingly." },
        ]
    },
    {
        item: "Incorporate the evolving needs and technical advancements:",
        subData: [
            { subItem: "Form a dedicated team to monitor technological shifts and user demands." },
            { subItem: "Adopt agile development for quick adaptations to changing requirements." },
            { subItem: "Stay updated on accessibility standards for compliance." },
            { subItem: "Collaborate with tech vendors and research institutes to integrate advanced technologies for improved navigation and accessibility." },
        ]
    },
    {
        item: "Facilitate user support and feedback mechanisms:",
        subData: [
            { subItem: "Engage with users through focus groups, surveys, or user testing sessions to gather qualitative insights into their needs and preferences." },
            { subItem: "Incorporate a comprehensive feedback mechanism within the app, allowing users to submit suggestions, report issues, and rate their experience." },
            { subItem: "Prioritise user-driven enhancements and bug fixes based on the severity of reported issues and the impact on user experience." },
            { subItem: "Regularly review and analyse user feedback and usage analytics to identify areas for improvement and prioritise feature enhancements." },
        ]
    },

]




